import React, { useCallback, useMemo } from "react";
import { connect } from "dvajs";
import lodashGet from "lodash/get";
import styles from "./shareqa.module.less";
import { ChatMessage, ChatMessageType } from "@/types/chat";
import { initChatMessageInfo } from "@/utils/chat/message";

interface IProps {
  message: any;
  selectedSession: any;
  currentEmployee: any;
  pushChatMessage: Function;
  updateLLMInfo: Function;
  llmSetting: any;
}

/**
 * 推荐问题卡片
 */
function ShareQACard(props: IProps) {
  const {
    message,
    selectedSession,
    currentEmployee,
    pushChatMessage,
    updateLLMInfo,
    llmSetting
  } = props;
  const dataInfos = lodashGet(message, "data", []);

  const buildMessage = useCallback(
    (content: string, opts: any) => {
      const messageBody = {
        type: ChatMessageType.TEXT,
        ...opts,
        content,
        question: content,
        isMyself: true
      };
      const message: Partial<ChatMessage> = initChatMessageInfo({
        selectedSession,
        currentEmployee,
        message: messageBody
      });
      return message;
    },
    [currentEmployee, selectedSession]
  );

  const handleClick = useCallback(
    (data: any) => {
      if (data) {
        const message = buildMessage(data, {});
        pushChatMessage({ sessionId: selectedSession.sessionId, message });
        updateLLMInfo(null);
      }
    },
    [buildMessage, pushChatMessage, selectedSession.sessionId, updateLLMInfo]
  );

  return (
    <div className={styles["ai-share-qa-card-wrap"]}>
      <span className={styles["title"]}>您可以这样问：</span>
      <div className={styles["content"]}>
        {dataInfos?.map((item: any, idx: number) => {
          return (
            <div
              clstag={`pageclick|keycount|Xtbg_YouCanAsk_${item}`}
              className={`${styles["item"]} ellipsis`}
              key={`share-qa_${idx}`}
              onClick={() => handleClick(item)}
            >
              {llmSetting?.recIcon ? <img src={llmSetting?.recIcon} /> : null}
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    llmSetting: chat.llmSetting
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage (data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    updateLLMInfo(data: any) {
      dispatch({ type: "chat/updateLLMInfo", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareQACard);
